interface TaskItemActionsProps {
  readonly isExpanded: boolean;
  readonly onToggleExpand: () => void;
  readonly onDelete: () => void;
}

export function TaskItemActions({
  isExpanded,
  onToggleExpand,
  onDelete,
}: TaskItemActionsProps) {
  return (
    <>
      <button
        type="button"
        onClick={onToggleExpand}
        aria-label={isExpanded ? "Réduire détails" : "Afficher détails"}
        className={`shrink-0 min-w-7 min-h-7 md:min-w-10 md:min-h-10 flex items-center justify-center
          text-ink-faint hover:text-ink focus:outline-none transition-transform text-xs md:text-base
          ${isExpanded ? "rotate-180" : ""}`}
      >
        ▼
      </button>

      <button
        type="button"
        onClick={onDelete}
        aria-label="Supprimer la tâche"
        className="shrink-0 min-w-7 min-h-7 md:min-w-10 md:min-h-10 flex items-center justify-center text-xs md:text-base
          text-ink-faint hover:text-danger focus:outline-none
          opacity-0 group-hover:opacity-100 md:opacity-0 max-md:opacity-100"
      >
        ✕
      </button>
    </>
  );
}
